// What counts as a supermarket: the one rule for the Supermercados page and the home page's «Super
// más cercano». The directory's «alimentación» also holds butchers, greengrocers and bakeries;
// only a known chain among them is a supermarket. The home page used to take all of «alimentación»,
// so it offered «CARNICERIA CARSUS» as your nearest supermarket while the page did not list it.

export const BRANDS = {
  'Alcampo': { color: '#DC2626', letter: 'A' },
  'Mercadona': { color: '#16A34A', letter: 'M' },
  'Lidl': { color: '#2563EB', letter: 'L' },
  'Carrefour': { color: '#1D4ED8', letter: 'C' },
  'ALDI': { color: '#EA580C', letter: 'A' },
  'Dia': { color: '#EF4444', letter: 'D' },
  'BM': { color: '#CA8A04', letter: 'B' },
  'Lupa': { color: '#7C3AED', letter: 'L' },
  'Supeco': { color: '#0F766E', letter: 'S' },
  'PrimaPrix': { color: '#DB2777', letter: 'P' },
};

// Whole words: «Dia» is the chain, not the «dia» inside another name.
const BRAND_RES = Object.keys(BRANDS).map((b) => [b, new RegExp(`(^|[^a-záéíóúñü])${b.toLowerCase()}([^a-záéíóúñü]|$)`)]);

export function brandOf(name) {
  const n = String(name || '').toLowerCase();
  const hit = BRAND_RES.find(([, re]) => re.test(n));
  return hit ? hit[0] : null;
}

export const isKnownChain = (name) => brandOf(name) !== null;

export function isSupermarket(shop) {
  if (!shop) return false;
  return shop.categoria === 'supermercado' || (shop.categoria === 'alimentación' && isKnownChain(shop.nombre));
}
